module.exports = __webpack_public_path__ + "static/media/checkedYellow.223509c7.svg";